import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { UserService } from "../service/user.service";
import { FeeService } from "../service/fee.service";
import { UserRole } from "../enums/UserRole";
import { catchError, map, of } from "rxjs";

export const feeMemberActiveGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const feeService = inject(FeeService);
  const router = inject(Router);
  const role = userService.role;
  const industryId = route.queryParamMap.get('industryId');

  if (role === UserRole.ADMIN) {
    return true;
  }

  if (industryId) {
    return true;
  }

  const memberId = Number(route.paramMap.get('memberId'));
  if (!memberId || isNaN(memberId)) {
    router.navigate(['/fees']);
    return false;
  }

  return feeService.getMemberProfile(memberId).pipe(
    map(profile => {
      if (!profile.active) {
        router.navigate(['/fees']);
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate(['/fees']);
      return of(false);
    })
  );
};
